import { render, staticRenderFns } from "./PeriodSummary.vue?vue&type=template&id=42d6774b&scoped=true"
import script from "./PeriodSummary.vue?vue&type=script&lang=js"
export * from "./PeriodSummary.vue?vue&type=script&lang=js"
import style0 from "./PeriodSummary.vue?vue&type=style&index=0&id=42d6774b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d6774b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d6774b')) {
      api.createRecord('42d6774b', component.options)
    } else {
      api.reload('42d6774b', component.options)
    }
    module.hot.accept("./PeriodSummary.vue?vue&type=template&id=42d6774b&scoped=true", function () {
      api.rerender('42d6774b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/PeriodSummary.vue"
export default component.exports